<div class="wrapper">
  @if (companies().length > 1) {
    <div motifDropdown>
      <button motifDropdownToggle aria-label="Company context" id="company-select-trigger">
        <div class="icon">
          <motif-icon [iconFunction]="companyIcon" size="16" title="Company context"></motif-icon>
        </div>

        <div class="company-name">
          <span class="company-name-label">
            {{ 'common.header.company-name' | translate }}
          </span>
          <br />
          <span [title]="currentCompanyName()">
            {{ currentCompanyName() }}
          </span>
        </div>
        <div class="dropdown-icon">
          <motif-icon [iconFunction]="arrowDownIcon" size="16" title="Switch Company"></motif-icon>
        </div>
      </button>
      <div motifDropdownMenu aria-labelledby="company-select-trigger">
        @for (company of companies(); track company.id) {
          <button motifDropdownItem (click)="selectCompany(company)">
            <div class="icon">
              <motif-icon [iconFunction]="companyIcon" size="16" title="Company context"></motif-icon>
            </div>

            <div class="company-name">{{ company.name | translate }}</div>

            @if (currentCompanyId() === company.id) {
              <motif-icon
                [iconFunction]="checkIcon"
                size="16"
                title="Selected"
                class="selected-company-icon"></motif-icon>
            }
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="icon">
      <motif-icon [iconFunction]="companyIcon" size="16" title="Company context"></motif-icon>
    </div>

    <div class="company-name">
      <span class="motif-caption-default-regular">
        {{ 'common.header.company-name' | translate }}
      </span>
      <br />
      <span class="motif-body2-default-light" [title]="currentCompanyName()">
        {{ currentCompanyName() }}
      </span>
    </div>
  }
</div>
